module.exports = __webpack_public_path__ + "img/exam_jan_2025_3apndzwa.14f426d3.jpg";